export interface CancelPreauthTarget {
    transactionId: string;
    amountMinor: number;
    terminalEpi: string | undefined;
    cancelling: boolean;
}

export const cancelPreauthDialogInitialState = {
    target: undefined as CancelPreauthTarget | undefined,
};

export type CancelPreauthDialogState = typeof cancelPreauthDialogInitialState;
